import fp from "lodash/fp";

import { AddColumnToNormalizationFormFields } from "globalConstants";
import { deleteEmptyValues } from "mappers";

const { columnFieldName, dataTypeFieldName, valueTypeFieldName } =
	AddColumnToNormalizationFormFields;

export const getMappedAddColumnToNormalizationForm = formValues => {
	return fp.flow(formValues => {
		const mappedValues = {
			column_name: formValues?.[columnFieldName],
			data_type: formValues?.[dataTypeFieldName]?.value || null,
			value_type: formValues?.[valueTypeFieldName]?.value || null,
		};

		return mappedValues;
	}, fp.tap(deleteEmptyValues))(formValues);
};
